import React from 'react'
import { Slider } from 'element-react'

const SliderSG = () => {
    // Constructor
    const value1 = 0
    const value2 = 50
    const value3 = 36
    const value4 = 48
    const value5 = 42

    // Format Tooltip
    const formatTooltip = val => {
        return val / 100
    }

    return (
        <div>
            {/* Slider ============================  */}
            <div className="block">
                <span className="demonstration">Default value</span>
                <Slider value={value1} />
            </div>
            <div className="block">
                <span className="demonstration">Customized initial value</span>
                <Slider value={value2} />
            </div>
            <div className="block">
                <span className="demonstration">Hide Tooltip</span>
                <Slider value={value3} showTooltip={false} />
            </div>
            <div className="block">
                <span className="demonstration">Format Tooltip</span>
                <Slider value={value4} formatTooltip={formatTooltip} />
            </div>
            <div className="block">
                <span className="demonstration">Disabled</span>
                <Slider value={value5} disabled={true} />
            </div>
        </div>
    )
}

export default SliderSG
